import { render, staticRenderFns } from "./ValidateCustomized.vue?vue&type=template&id=ee56f8d6&"
import script from "./ValidateCustomized.vue?vue&type=script&lang=ts&"
export * from "./ValidateCustomized.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports